import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  CampaignInventory,
  Character,
  CharacterInventory,
  Money
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  char: Character | Campaign;
  inventory: CharacterInventory | CampaignInventory;
}

export default function CharacterCurrency({
  char,
  inventory
}: Props) {
  // const [reloading, setReloading] = useState(false);
  const [platinum, setPlatinum] = useState(0);
  const [gold, setGold] = useState(0);
  const [electrum, setElectrum] = useState(0);
  const [silver, setSilver] = useState(0);
  const [copper, setCopper] = useState(0);

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  const renderTypes = () => {
    return (
      <>
        { renderType("Platinum", "= 10 GP") }
        { renderType("Gold", "= 10 SP") }
        { renderType("Electrum", "= 5 SP") }
        { renderType("Silver", "= 10 CP") }
        { renderType("Copper") }
      </>
    );
  }

  const renderType = (type: string, detail = "") => {
    return (
      <>
        <Grid
          size={{
            xs: 10
          }}>
          <div style={{ 
            fontSize: "12px", 
            fontWeight: "bold",
            height: "12px" 
            }}>
            { type }
          </div>
          <div className='small_label gray padded'>
            { detail }
          </div>
        </Grid>
        <Grid
          style={{ fontSize: "12px", fontWeight: "bold" }}
          size={{
            xs: 2
          }}>
          { (inventory.money as any)[type.toLowerCase()] }
        </Grid>
      </>
    );
  }

  return (
    <div 
      style={{ 
        height: "100%",
        overflowX: "hidden",
        padding: "4px",
        fontSize: "11px"
      }}>
      <Grid container spacing={0} direction="row"
        style={{ 
          // backgroundColor: "white",
          // color: "black",
          overflowX: "hidden"
        }}>
        <Grid
          className="header centered"
          style={{ fontSize: "18px" }}
          size={{
            xs: 12
          }}>
          Currency
        </Grid>
        <Grid
          className="centered"
          size={{
            xs: 12
          }}>
          Total Currency in GP
        </Grid>
        <Grid
          className="centered"
          size={{
            xs: 12
          }}>
          { inventory.money.gold_value() }
        </Grid>
        { renderTypes() }
        <Grid
          className="centered"
          size={{
            xs: 12
          }}>
          <span>
            <StringBox 
              name="Platinum"
              value={`${platinum}`}
              type="number"
              onBlur={(changed: string) => {
                setPlatinum(+changed);
              }}
            />
          </span>
          <span>
            <StringBox 
              name="Gold"
              value={`${gold}`}
              type="number"
              onBlur={(changed: string) => {
                setGold(+changed);
              }}
            />
          </span>
          <span>
            <StringBox 
              name="Electrum"
              value={`${electrum}`}
              type="number"
              onBlur={(changed: string) => {
                setElectrum(+changed);
              }}
            />
          </span>
          <span>
            <StringBox 
              name="Silver"
              value={`${silver}`}
              type="number"
              onBlur={(changed: string) => {
                setSilver(+changed);
              }}
            />
          </span>
          <span>
            <StringBox 
              name="Copper"
              value={`${copper}`}
              type="number"
              onBlur={(changed: string) => {
                setCopper(+changed);
              }}
            />
          </span>
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CenteredMenu 
            options={["Add","Remove","Clear"]}
            selected={""}
            onSelect={(view: string) => {
              if (view !== "Clear") {
                const money = inventory.money;
                try {
                  const change = new Money();
                  change.platinum = +platinum;
                  change.gold = +gold;
                  change.electrum = +electrum;
                  change.silver = +silver;
                  change.copper = +copper;
                  if (view === "Remove") {
                    money.subtract(change);
                  } else {
                    money.add(change);
                  }
                  char.changed();
                  char.subscription_holder.itemsChanged();
                } catch {
                  
                }
              }
              setPlatinum(0);
              setGold(0);
              setElectrum(0);
              setSilver(0);
              setCopper(0);
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
}
